import { Component, Input  /*Output, EventEmitter*/, Inject } from "@angular/core";
// import { NgbDateParserFormatter } from "@ng-bootstrap/ng-bootstrap";
// import { NgbDateFRParserFormatter } from "../../providers/datepicker-format";
import { HttpService } from "../../providers/http.service";
import { FormControl } from "@angular/forms";
import { Observable } from "rxjs";
import { SchedulesService } from "src/providers/schedules.service";
import { UtilsProvider } from "src/commons/utils";
import { NgxViacepModule } from "@brunoc/ngx-viacep";
import { ENV } from "../../environments/environment-variables.token";
import { HttpClient } from "@angular/common/http";
import { UserTypesService } from "../../providers/user-types.service";
/**
 * Generated class for the DefaultFormComponent component.
 *
 * See https://angular.io/docs/ts/latest/api/core/index/ComponentMetadata-class.html
 * for more info on Angular Components.
 */


@Component({
	selector: "default-form",
	templateUrl: "default-form.html",
	styleUrls: ["./default-form.scss"],
	// providers: [{ provide: NgbDateParserFormatter, useClass: NgbDateFRParserFormatter }],
})
export class DefaultFormComponent {

	/*
		- TODO:
			- CREATE ION-SELECT FUNCTIONALhedule
			- FIND OR CREATE A FUNCTIONING MASK FOR INPUTS
			- BACK, NEXT AND SUBMIT SHOULD RETURN PROMISES FOR BACKEND VALIDATION

		- Example of how to build the parameters for this component.

		- The *back*, *next* and *submit* are EventEmitter for the parent page. Can perform validations on back-end, for instance, checking for user"s e-mail

		- The *step* attribute should be an integer, depending on which step of the form you want to see. Usually it is 0, but for debug purposes it can be changed
			step = 0

		- The *forms* object is the most important attribute of this component. It should have these attributes:
			- The *title* attribute is the title of that form
				title: "Login Data"
			- The *fields* attribute builds the layout of the form accordingly
				fields: {name, label, icon, type}
				- Declaring explicitly the FormControls is not necessary, however in order to use CustomValidators plugin equalTo, for instance, it is necessary
			- The *builder* attribute receives a FormBuilder object to create the form validation. The attributes provided should match the *fields* attr
				builder: FormBuilder object
			- The *validation_messages* attribute receives an array for each form attribute, and each array should provide the messages to return when there is an error in each validation

		- Full Example:

					const email = new FormControl("", Validators.compose([Validators.required, Validators.email]))
					const confirm_email = new FormControl("", CustomValidators.equalTo(email))
					const password = new FormControl("", Validators.compose([Validators.required, Validators.minLength(6)]))
					const confirm_password = new FormControl("", CustomValidators.equalTo(password))

					const name = new FormControl("", Validators.compose([Validators.required, Validators.minLength(5), Validators.maxLength(50)]))
					const phone = new FormControl("", Validators.compose([Validators.required, Validators.pattern(/^(?:(?:\+|00)?(55)\s?)?(?:\(?([1-9][0-9])\)?\s?)?(?:((?:9\d|[2-9])\d{3})\-?(\d{4}))$/)]))

					step = 0
					forms = [
						{
							fields: [
								{
									name: "email",
									label: "E-mail",
									icon: "fa-envelope-o",
									type: "email"
								},
								{
									name: "confirm_email",
									label: "Confirmar e-mail",
									icon: "fa-envelope-o",
									type: "email"
								},
							],
							builder: this.formBuilder.group({
								email,
								confirm_email,
							}),
							validation_messages: {
								email: [
									{type: "required", message: "Preencha o campo e-mail."},
									{type: "email", message: "E-mail inválido."}
								],
								confirm_email: [
									{type: "equalTo", message: "Deve ser igual ao campo e-mail."}
								],
							}
						}
					]

					back() {
						this.step--
					}

					next() {
						this.step++
					}

					submit() {

					}
	*/

	@Input() forms: any;
	@Input() step: any;
	@Input() controller: any;
	search: any;
	searchList = "";
	searchItens: any;
	result: any;
	total: any;
	delay: any;
	selectedItem: any;
	myControl = new FormControl();
	filteredOptions: Observable<string[]>;
	busca: any;
	timer = null;
	searchResult: any;
	private conteudo: Boolean = true;
	private chaveApiCrm = 6180831371;
	public siglaEstados = [
        {nome: "Acre", sigla: "AC"},
        {nome: "Alagoas", sigla: "AL"},
        {nome: "Amapá", sigla: "AP"},
        {nome: "Amazonas", sigla: "AM"},
        {nome: "Bahia", sigla: "BA"},
        {nome: "Ceará", sigla: "CE"},
        {nome: "Distrito Federal", sigla: "DF"},
        {nome: "Espírito Santo", sigla: "ES"},
        {nome: "Goiás", sigla: "GO"},
        {nome: "Maranhão", sigla: "MA"},
        {nome: "Mato Grosso", sigla: "MT"},
        {nome: "Mato Grosso do Sul", sigla: "MS"},
        {nome: "Minas Gerais", sigla: "MG"},
        {nome: "Pará", sigla: "PA"},
        {nome: "Paraíba", sigla: "PB"},
        {nome: "Paraná", sigla: "PR"},
        {nome: "Pernambuco", sigla: "PE"},
        {nome: "Piauí", sigla: "PI"},
        {nome: "Rio de Janeiro", sigla: "RJ"},
        {nome: "Rio Grande do Norte", sigla: "RN"},
        {nome: "Rio Grande do Sul", sigla: "RS"},
        {nome: "Rondônia", sigla: "RO"},
        {nome: "Roraima", sigla: "RR"},
        {nome: "Santa Catarina", sigla: "SC"},
        {nome: "São Paulo", sigla: "SP"},
        {nome: "Sergipe", sigla: "SE"},
        {nome: "Tocantins", sigla: "TO"}

	];
	private crm: any;
	private uf: any;
	constructor(
		private httpService: HttpService,
		private schedule: SchedulesService,
		private utils: UtilsProvider,
		private http: HttpClient,
		@Inject(ENV) public ENV: any
	) {
		console.log("Hello DefaultFormComponent Component");
		this.init();
	}
	init(): any {
		const self: any = this;
		if (this.controller) {
			this.controller.defaultForm = this;
		} else {
			setTimeout(() => {
				self.init();
			}, 500);
		}
	}

	searchCity(busca) {
		const self = this;
		self.busca = busca;
		if (self.busca && self.busca.length >= 3) {
			clearTimeout(self.timer);
			self.timer = setTimeout(async () => {
				self.search = [];
				let err, result;
				[err, result] = await self.utils.tryCatch(self.schedule.searchUsersByService({ service: self.busca }));
				if (!err) { self.search = self.search.concat(result.items); }
				self.searchResult = self.search;
				if (self.search.length === 0) { self.conteudo = false; } else { self.conteudo = true; }
			}, 1800);
		}
	}

	getItensBySearch(url: string): any {
		clearTimeout(this.delay);
		this.delay = setTimeout(() => {
			const data: any = { find: this.search };
			this.httpService.post(url, true, { data }).then((res: any) => {
				console.log("RES: ", res);
				this.searchItens = res.itens;
				this.total = res.total;
			})
				.catch(err => { console.log(err); });
		}, 500);
	}
	getByEmailList(url: string, calback: any): any {
		clearTimeout(this.delay);
		this.delay = setTimeout(() => {
			const data: any = { find: this.searchList };
			this.httpService.post(url, true, { data }).then((res: any) => {
				if (res.itens) {
					calback(res.itens);
				}
			})
				.catch(err => { console.log(err); });
		}, 500);
	}
	getImage(item: any): any {
		return item.images[0] ? String(item.images[0].host) + String(item.images[0].thumb) : "assets/images/default-avatar.png";
	}
	selectItem(item: any, callback: any): any {
		this.selectedItem = item;
		this.result = item._id;
		this.searchItens = undefined;
		if (callback) { callback(item); }
	}
	setValue(event, formB, field) {
		console.log("event", event.target.value);
		console.log("formB", formB);
		formB.value = event.target.value;
		// formB.valueChanges.observer({
		// 	next: (value) => {
		// 		formB.updateValueAndValidity();
		// 	}
		// });
		formB.updateValueAndValidity();
	}
	crmValidate(event, field, type = "crm") {
		console.log("event", event);
		clearTimeout(this.delay);
		if (type === "crm") { this.crm = event.target.value; }
		if (type === "uf") { this.uf = event.value; }
		if (this.crm < 4 || (!this.crm || !this.uf)) { return; }

		this.delay = setTimeout(() => {
			field.markAsTouched({ onlySelf: true });
			const data: any = { find: this.searchList };
			this.httpService.get("api/user-types/user-types/validateCrm/?crm=" + this.crm + "&uf=" + this.uf, true)
			.then((res: any) => {
				if (res && !res[0]) {
					// formB.setError({notFound: true});
					field.value = undefined;
					field.updateValueAndValidity();
					return this.utils.toast({message: "CRM não encontrado"});
				} else if (res[0] && !res[0]["situacao"] || res[0]["situacao"] !== "Ativo")  {
					// formB.setError({invalid: true});
					field.value = undefined;
					field.updateValueAndValidity();
					return this.utils.toast({message: "CRM inválido ou inativo"});
				} else {
					field.value =  res[0];
					field.updateValueAndValidity();
				}


			})
			.catch(err => { console.log(err); });
		}, 2000);


	}
	onItemSelect(item: any) {
		console.log(item);
	}
	onSelectAll(items: any) {
		console.log(items);
	}
	onFileEmmit(ev, field) {
		console.log("event", ev);
	}
}
